export default __webpack_public_path__ + "static/media/Satellite_alpha_bg.b39ffa6c.png";